import { render, staticRenderFns } from "./p1s1c1CustomersInQueue.vue?vue&type=template&id=fc2a031a&scoped=true"
import script from "./p1s1c1CustomersInQueue.vue?vue&type=script&lang=js"
export * from "./p1s1c1CustomersInQueue.vue?vue&type=script&lang=js"
import style0 from "./p1s1c1CustomersInQueue.vue?vue&type=style&index=0&id=fc2a031a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2a031a",
  null
  
)

export default component.exports